import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";

interface SetDefaultFyCycleDialogProps {
  open: boolean;
  optionName: string;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function SetDefaultFyCycleDialog({
  open,
  optionName,
  onConfirm,
  onDismiss,
}: SetDefaultFyCycleDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onDismiss()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Set as workspace default?</AlertDialogTitle>
          <AlertDialogDescription>
            Set &quot;{optionName}&quot; as the default FY cycle for new test
            sessions in this workspace?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDismiss}>No</AlertDialogCancel>
          <Button onClick={onConfirm}>Yes, set as default</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
